// JM Size Guide position alignment script

document.addEventListener("DOMContentLoaded", function () {

  function moveSizeGuide() {
    const chart = document.querySelector('.ks-chart-container');
    const sizeOption = document.querySelector('[data-option="Size"]');

    if (!chart || !sizeOption) return false;

    const sizeSection = sizeOption.closest('.PwzrGrid-item');

    if (sizeSection && !sizeSection.contains(chart)) {
      sizeSection.appendChild(chart);
      return true;
    }

    return false;
  }

  // Retry logic (handles delayed loading)
  let attempts = 0;
  const maxAttempts = 30;

  const retryInterval = setInterval(() => {
    const success = moveSizeGuide();
    attempts++;

    if (success || attempts >= maxAttempts) {
      clearInterval(retryInterval);
    }
  }, 400);

  // Watch for dynamic changes (variant change, re-render)
  const observer = new MutationObserver(() => {
    moveSizeGuide();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});